<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout align-center justify-space-around wrap>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card flat style="background: #FAFAFA;">
          <v-responsive>
            <photo-card :photoJson="photo" :cardStyle="cardStyle"></photo-card>
          </v-responsive>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm4 md2 lg2 xl8>
        <v-card tile flat>
          <v-card-text>
            <div v-html="photo.description"></div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm8 md10 lg8 xl8>
        <v-card tile flat>
          <photo-map :location="photo.location"></photo-map>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import photosJsonConfig from '../photos.json';
import PhotoMap from '@/components/PhotoMap.vue';
import PhotoCard from '@/components/PhotoCard.vue';

export default {
  name: 'photo-details',
  props: {
    photoId: {
      required: true,
    },
  },
  components: {
    PhotoCard,
    PhotoMap,
  },
  data() {
    return {
      photoIndex: null,
      photo: photosJsonConfig.find(this.filterPhoto) || null,
      cardStyle: 'background: #FAFAFA;',
    };
  },
  methods: {
    filterPhoto(photoJson) {
      return photoJson.pindex === Number(this.photoId);
    },
  },
  computed: {
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;
      return binding;
    },
  },
};
</script>
